import React, { useEffect, useState } from "react"
import { useParams, useNavigate } from "react-router-dom"
import LayoutCommon from "src/components/Common/Layout"
import { allProducts, detailProducts, techFeatures } from "../data/productsData"
import { Image, Row, Col, Typography, List, Form, Input, Space } from "antd"
import {
  CardDetail,
  ThumbnailContainer,
  Thumbnail,
  RatingCourseWrapper,
  CardInformation,
  StyledList,
  StyledUl,
  FeatureContainer,
  ImageContainer,
  FeatureTitle,
  StyledProductDetail,
} from "../styled"
import ROUTER from "src/router"
import Button from "src/components/MyButton/Button"
import { Rate } from "antd"
import Notice from "src/components/Notice"
import { MessageOutlined } from "@ant-design/icons"
import CardItem from "../components/CardProduct"

export default function DetailSolution() {
  const { id } = useParams()
  const desc = ["Rất tệ", "Tệ", "Bình thường", "Tốt", "Tuyệt vời"]
  const product = allProducts.find(p => p.id === Number(id))
  const { Title, Paragraph } = Typography
  const [selectedImage, setSelectedImage] = useState("")
  const [reviews, setReviews] = useState(product.reviews)
  const [newReview, setNewReview] = useState({ rating: 0, comment: "" })
  const [filterRating, setFilterRating] = useState(null)
  const navigate = useNavigate()
  const [startIndex, setStartIndex] = useState(0)
  const maxThumbnails = 5
  const totalImages = product.images.length
  const [quantity, setQuantity] = useState(1)
  const visibleThumbnails = product.images.slice(
    startIndex,
    startIndex + maxThumbnails,
  )

  useEffect(() => {
    if (product) {
      setSelectedImage(product?.images?.[0] || "")
      setReviews(product.reviews || [])
      setStartIndex(0)
      setQuantity(1)
      setNewReview({ rating: 0, comment: "" })
      setFilterRating(null)
    }
  }, [id, product])

  const handlePrevious = () => {
    setStartIndex(prev =>
      prev - 1 >= 0 ? prev - 1 : totalImages - maxThumbnails,
    )
  }

  const handleNext = () => {
    setStartIndex(prev => {
      if (prev + 1 <= totalImages - maxThumbnails) {
        return prev + 1
      }
      return 0
    })
  }
  const [detailNews, setDetailNews] = useState()
  const averageRating = product.reviews.length
    ? (
        product.reviews.reduce((sum, review) => sum + review.rating, 0) /
        product.reviews.length
      ).toFixed(1)
    : 0
  if (!product) {
    return (
      <LayoutCommon>
        <p>Không tìm thấy sản phẩm</p>
      </LayoutCommon>
    )
  }

  const filteredReviews =
    filterRating !== null
      ? reviews.filter(review => review.rating === filterRating)
      : reviews

  const handleReviewSubmit = () => {
    if (newReview.rating === 0) {
      Notice({ isSuccess: false, msg: "Vui lòng chọn ít nhất 1 sao!" })
      return
    }

    if (newReview.comment.trim()) {
      setReviews([...reviews, newReview])
      setNewReview({ rating: 0, comment: "" })

      Notice({ isSuccess: true, msg: "Đánh giá thành công" })
    }
  }

  const handleQuantity = type => {
    setQuantity(prev => {
      if (type === "increment" && prev < 20) return prev + 1
      if (type === "decrement" && prev > 1) return prev - 1
      return prev
    })
  }

  // Filter related products from the same category, excluding the current product, limited to 8
  const relatedProducts = allProducts
    .filter(p => p.categoryId === product.categoryId && p.id !== product.id)
    .slice(0, 8)

  return (
    <LayoutCommon>
      <StyledProductDetail>
        <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
          <Col xs={24} md={8} lg={8} xl={8} style={{ marginLeft: "0px" }}>
            <CardDetail>
              <Image src={selectedImage} alt={product.title} width="100%" />
            </CardDetail>

            <ThumbnailContainer>
              {totalImages > maxThumbnails && (
                <Button onClick={handlePrevious}>◀</Button>
              )}

              {visibleThumbnails.map((img, index) => (
                <Thumbnail
                  key={index}
                  src={img}
                  alt="thumbnail"
                  onClick={() => setSelectedImage(img)}
                  active={selectedImage === img}
                />
              ))}

              {totalImages > maxThumbnails && (
                <Button onClick={handleNext}>▶</Button>
              )}
            </ThumbnailContainer>
          </Col>

          <Col xs={24} md={16} lg={16} xl={16}>
            <Title level={3}>{product.title}</Title>
            <Paragraph>{product.description}</Paragraph>
            <Row>
              <Rate allowHalf disabled value={averageRating} />
              <span style={{ marginLeft: 8 }}>({averageRating})</span>
              <span style={{ marginLeft: 8, color: "#666" }}>
                <MessageOutlined style={{ marginRight: 4 }} />
                {product.reviews.length} đánh giá
              </span>
            </Row>
            <Row style={{ marginTop: 16, alignItems: "center" }}>
              <Col xs={24} sm={8} md={6} lg={6} xl={4}>
                <Typography.Text strong>Số lượng:</Typography.Text>
              </Col>
              <Col xs={24} sm={16} md={18} lg={18} xl={8}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Button
                    style={{
                      border: "1px",
                      boxShadow: "none",
                      background: "#f5f5f5",
                    }}
                    onClick={() => handleQuantity("decrement")}
                  >
                    -
                  </Button>

                  <span
                    style={{
                      padding: "0 12px",
                      borderLeft: "1px solid #d9d9d9",
                      borderRight: "1px solid #d9d9d9",
                      minWidth: 40,
                      textAlign: "center",
                    }}
                  >
                    {quantity}
                  </span>

                  <Button
                    style={{
                      border: "none",
                      boxShadow: "none",
                      background: "#f5f5f5",
                    }}
                    onClick={() => handleQuantity("increment")}
                  >
                    +
                  </Button>
                </div>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={6}>
                <span style={{ marginLeft: 8 }}>
                  {product.inStock} sản phẩm có sẵn
                </span>
              </Col>
            </Row>
            {/* <Title level={4} style={{ color: "red", marginTop: "16px" }}>
              {(product.price * (1 - product.sale / 100)).toLocaleString(
                "vi-VN",
              )}
              <span style={{ textDecoration: "underline" }}>đ</span>
            </Title>
            <Row>
              <Paragraph
                style={{
                  textDecorationLine: "line-through",
                  color: "#C3BDBD",
                  margin: "0",
                }}
              >
                {product.price.toLocaleString("vi-VN")}đ
              </Paragraph>
              <div
                style={{
                  backgroundColor: "#FFC107",
                  color: "white",
                  padding: "2px 8px",
                  borderRadius: "4px",
                  marginLeft: "8px",
                  fontSize: "14px",
                  fontWeight: "bold",
                }}
              >
                -{product.sale}%
              </div>
            </Row> */}
            <Row>
              <Space size={16} style={{ width: "100%" }}>
                {/* <div
                  className="buy-product"
                  style={{ marginTop: "8px", width: "100%" }}
                >
                  <Button
                    className="btn-hover-shadow"
                    btnType="red"
                    onClick={() => {
                      !!(detailNews?.PackageType === 2)
                        ? detailNews?.Link
                          ? navigate(ROUTER?.DANH_SACH_KHOA_HOC)
                          : navigate(ROUTER.DAT_DICH_VU, {
                              state: { product: detailNews },
                            })
                        : navigate(ROUTER.THANH_TOAN_SAN_PHAM, {
                            state: { product: detailNews },
                          })
                    }}
                    style={{ width: "100%" }}
                  >
                    {!!(detailNews?.PackageType === 2)
                      ? detailNews?.Link
                        ? "Xem chi tiết"
                        : "Liên hệ "
                      : "Mua ngay"}
                  </Button>
                </div> */}
                {!(detailNews?.PackageType === 2) && (
                  <div className="buy-product2 mt-10" style={{ width: "100%" }}>
                    <div style={{ width: "100%" }}>
                      <Button
                        className="btn-hover-shadow"
                        btnType="primary"
                        onClick={() => {
                          navigate("/lien-he", {
                            state: { product: detailNews },
                          })
                        }}
                        style={{ width: "100%" }}
                      >
                        Liên hệ
                      </Button>
                    </div>
                  </div>
                )}
              </Space>
            </Row>
          </Col>
        </Row>

        <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
          <Col>
            <Title level={3} style={{ color: "red" }}>
              Chi tiết sản phẩm
            </Title>
          </Col>
        </Row>

        <CardInformation>
          <Title level={3}>Tổng quan</Title>
          <Row style={{ height: "100%" }}>
            <Col xs={24} md={14} lg={14} xl={14}>
              <StyledList
                dataSource={
                  detailProducts.find(d => d.id === product.detailId)
                    ?.overview || []
                }
                renderItem={item => (
                  <List.Item>
                    <StyledUl>
                      <li>{item}</li>
                    </StyledUl>
                  </List.Item>
                )}
              />
            </Col>
            <Col
              xs={24}
              md={10}
              lg={10}
              xl={10}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: 16,
              }}
            >
              <div style={{ height: "100%" }}>
                <Image
                  src={product?.images?.[0]}
                  alt={product.title}
                  preview={false}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </div>
            </Col>
          </Row>

          <Title level={3} style={{ marginTop: 24 }}>
            Thông số kỹ thuật
          </Title>
          <StyledList column={1}>
            {detailProducts
              .find(d => d.id === product.detailId)
              ?.techInfor.map((item, index) => (
                <List.Item key={index}>
                  <StyledUl>
                    <li>{item}</li>
                  </StyledUl>
                </List.Item>
              ))}
          </StyledList>

          <Title level={3} style={{ marginTop: 24 }}>
            Tính năng
          </Title>
          <Row gutter={[16, 16]}>
            {techFeatures
              .filter(tf =>
                detailProducts
                  .find(d => d.id === product.detailId)
                  ?.techFeaturesId.includes(tf.id),
              )
              .map(feature => (
                <Col xs={24} sm={12} md={8} lg={6} xl={6} key={feature.id}>
                  <FeatureContainer>
                    <ImageContainer>
                      <Image
                        src={feature.image}
                        alt={feature.title}
                        preview={false}
                        width={80}
                        height={80}
                        style={{ objectFit: "contain" }}
                      />
                    </ImageContainer>
                    <FeatureTitle level={4}>{feature.title}</FeatureTitle>
                    <StyledList
                      dataSource={feature.description}
                      renderItem={item => (
                        <List.Item>
                          <StyledUl>
                            <li>{item}</li>
                          </StyledUl>
                        </List.Item>
                      )}
                    />
                  </FeatureContainer>
                </Col>
              ))}
          </Row>
        </CardInformation>

        <CardInformation style={{ marginTop: 24 }}>
          <Title level={3}>Đánh giá nhận xét</Title>
          <RatingCourseWrapper>
            <div style={{ marginTop: 16, width: "100%" }}>
              <div
                className="filter-buttons"
                style={{ marginBottom: 16, display: "flex", overflowX: "auto" }}
              >
                {[...Array(6)].map((_, i) => {
                  const count =
                    i === 0
                      ? reviews.length
                      : reviews.filter(review => review.rating === i).length

                  return (
                    <Button
                      key={i}
                      type={
                        filterRating === (i === 0 ? null : i)
                          ? "primary"
                          : "default"
                      }
                      onClick={() => setFilterRating(i === 0 ? null : i)}
                      style={{
                        marginRight: 8,
                        display: "flex",
                        alignItems: "center",
                        borderRadius: "8px",
                        flexShrink: 0,
                      }}
                    >
                      {i === 0 ? (
                        "Tất cả"
                      ) : (
                        <>
                          <Rate
                            disabled
                            value={i}
                            style={{ fontSize: 16, marginRight: 4 }}
                            count={i}
                          />
                          <span>({count})</span>
                        </>
                      )}
                    </Button>
                  )
                })}
              </div>

              <Form onFinish={handleReviewSubmit}>
                <Form.Item label="Đánh giá">
                  <Rate
                    value={newReview.rating}
                    tooltips={desc}
                    onChange={value =>
                      setNewReview({ ...newReview, rating: value })
                    }
                  />
                </Form.Item>
                <Form.Item label="Bình luận">
                  <Input.TextArea
                    value={newReview.comment}
                    onChange={e =>
                      setNewReview({ ...newReview, comment: e.target.value })
                    }
                  />
                </Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ borderRadius: "8px" }}
                >
                  Gửi đánh giá
                </Button>
              </Form>

              <List
                itemLayout="horizontal"
                dataSource={filteredReviews}
                renderItem={item => (
                  <List.Item>
                    <List.Item.Meta
                      title={<Rate disabled value={item.rating} />}
                      description={item.comment}
                    />
                  </List.Item>
                )}
              />
            </div>
          </RatingCourseWrapper>
        </CardInformation>

        <Col span={24} style={{ marginTop: 48 }}>
          <Row>
            <Title level={2}>Sản phẩm liên quan</Title>
          </Row>
          <CardItem
            products={relatedProducts.map(p => p.id)}
            filters={{
              sortBy: "",
              categories: [product.categoryId],
              priceRange: [0, 1000000000],
            }}
          />
        </Col>
      </StyledProductDetail>
    </LayoutCommon>
  )
}
